// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const JournalCoverageSummary = () => ({
   replace: true,
   templateUrl: '/assets/journalCoverageSummary.html',
   controllerAs: 'jc',
   controller: JournalCoverageSummaryController,

   bindToController: { 
      coverageRange: '<',
      gapRange: '<',
      moreGap: '<',
      context: '<'
   }
})

const JournalCoverageDetails = () => ({
   replace: true,
   templateUrl: '/assets/journalCoverageDetails.html',
   controllerAs: 'jcd',
   controller: JournalCoverageDetailsController
})

const JournalCoverageDetailsContent = () => ({
   replace: true,
   templateUrl: '/assets/journalCoverageDetailsContent.html',
   controllerAs: 'content',
   controller: JournalCoverageDetailsContentController,

   bindToController: {
      quickLook: '<'
   }
})

class JournalCoverageSummaryController {
   $scope: any
   i18n: any
   constructor($scope: any, translationService: any) {
      this.$scope = $scope
      this.i18n = translationService
   }
}


class JournalCoverageDetailsController {
   $scope: any
   i18n: any
   constructor($scope: any, translationService: any) {
      this.$scope = $scope
      this.i18n = translationService
   }
}

class JournalCoverageDetailsContentController {
   $scope: any
   i18n: any
   constructor($scope: any, translationService: any) {
      this.$scope = $scope
      this.i18n = translationService
   }
}

JournalCoverageSummaryController.$inject = ['$scope', 'translationService']
JournalCoverageDetailsController.$inject = ['$scope', 'translationService']
JournalCoverageDetailsContentController.$inject = ['$scope', 'translationService']


angular.module('summonApp.directives')
   .directive('journalCoverageSummary', JournalCoverageSummary)
   .directive('journalCoverageDetails', JournalCoverageDetails)
   .directive('journalCoverageDetailsContent', JournalCoverageDetailsContent)
   .controller('journalCoverageSummaryController', JournalCoverageSummaryController)
   .controller('journalCoverageDetailsController', JournalCoverageDetailsController)
   .controller('journalCoverageDetailsContentController', JournalCoverageDetailsContentController)
